import MessageContainer from './MessageContainer';

export default MessageContainer;
